/** Read mhop role claim with legacy behavioralHealth / role-string fallback. */
export const hasMhopClaim = (claims = {}) => {
  return (
    claims.mhop === true ||
    claims.behavioralHealth === true ||
    normalizeRoleToMhop(claims.role) === 'mhop'
  );
};

/** MHOP staff: JWT claims and/or Firestore profile role (legacy clinician/BH included). */
export const userHasMhopAccess = (claims = {}, firestoreRole = '') => {
  return hasMhopClaim(claims) || normalizeRoleToMhop(firestoreRole) === 'mhop';
};

export const userHasMhopAccessFromContext = (user = {}) => {
  if (!user) {
    return false;
  }
  return (
    userHasMhopAccess(user.claims || user.customClaims || {}, user.role) ||
    user.isMhop === true ||
    user.isBehavioralHealth === true
  );
};

/** Normalize legacy role keys to mhop. */
export const normalizeRoleToMhop = (role) => {
  if (role === 'behavioralHealth' || role === 'behavioral_health' || role === 'clinician') {
    return 'mhop';
  }
  return role;
};

/** Canonical client group key for MHOP caseload (legacy: behavioral_health). */
export const MHOP_CLIENT_GROUP = 'mhop';

export const LEGACY_MHOP_CLIENT_GROUPS = ['behavioral_health', 'behavioralHealth'];

export const isMhopClientGroup = (group) => {
  return group === MHOP_CLIENT_GROUP || LEGACY_MHOP_CLIENT_GROUPS.includes(group);
};

export const clientHasMhopGroup = (groups = []) => {
  return Array.isArray(groups) && groups.some((g) => isMhopClientGroup(g));
};

/** Read client mhop tracker field with legacy fallback. */
export const getMhopTracker = (client = {}) => {
  return client.mhopTracker ?? client.behavioralHealthTracker ?? null;
};

/** Read client mhop assignment field with legacy fallback. */
export const getMhopAssignment = (client = {}) => {
  return client.mhopAssignment ?? client.behavioralHealthAssignment ?? null;
};
